import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDTitleText } from '@facet-wealth/design';

const ScenarioSelectionChartsMetaOverride = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDTitleText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly);

export default ScenarioSelectionChartsMetaOverride;
